import { Logo } from '@/components/Logo';
import { useBrand } from '@/hooks/useBrand';
import { cn } from '@/lib/utils';

interface BrandedLogoProps {
  size?: string;
  className?: string;
  /** Override brand context (for pages where BrandContext is unavailable, e.g. invite page). */
  overrideLogoUrl?: string | null;
  overrideCompanyName?: string | null;
}

/** Logo with fallback chain: brand logo_url -> Watt Tower logo. */
export function BrandedLogo({ size = 'h-9', className, overrideLogoUrl, overrideCompanyName }: BrandedLogoProps) {
  const { logoUrl, companyName } = useBrand();
  const url = overrideLogoUrl ?? logoUrl;
  const name = overrideCompanyName ?? companyName;

  if (url) {
    return (
      <img
        src={url}
        alt={name}
        className={cn('w-auto object-contain', size, className)}
      />
    );
  }

  return <Logo variant="iconTransparent" size={size} className={className} />;
}
